import { ApplicationConfig, inject, provideBrowserGlobalErrorListeners, provideEnvironmentInitializer, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { windowProvider, WindowToken } from './core/browser/window.provider';
import { AuthInterceptor } from './http/auth-interceptor';
import { provideStore } from '@ngxs/store';
import { AppState } from './state/app.state';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { CUSTOM_ICONS } from './shared/components/kon-icon/custom-icons';
import { NgxKonIconService } from '@bykonstrukt/ngx-ux-components';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideStore([AppState]),
    provideHttpClient(withInterceptorsFromDi()),
    provideEnvironmentInitializer(() => inject(NgxKonIconService).registerMany(CUSTOM_ICONS)),
    { provide: WindowToken, useFactory: windowProvider },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    // CDK Overlay (used by CDK Dialog) opts into the Popover API by default,
    // which renders dialogs in the browser's top layer and makes them stack
    // above any regular-DOM element regardless of z-index — including ng-bootstrap
    // dropdowns re-parented to <body>. Disable popover to fall back to z-index stacking.
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } }
  ],
};
